// Copyright 2026. WebPros International GmbH. All rights reserved.
import styled from 'styled-components';

export const EmptyView = styled.div`
    text-align: center;
    padding: 30px 0;
`;

export const HistoryTableWrapper = styled.div`
    .pul-list {
        /* #101 + #105: Reduce table header height and vertically center all header cells */
        .pul-list__table-thead th {
            height: 36px;
            padding-top: 4px !important;
            padding-bottom: 4px !important;
            vertical-align: middle;
        }

        /* #105: Center the Collapse All button horizontally */
        .pul-list__table-thead .pul-list__cell-expander {
            text-align: center;
        }

        /* #100: All data rows must be 62px tall */
        tr:not(.pul-list__row-body):not(.pul-list__table-thead) {
            height: 62px;
        }

        /* #100 + #94: Vertically center cell content and reduce vertical padding */
        td {
            vertical-align: middle;
            padding-top: 6px !important;
            padding-bottom: 6px !important;
        }

        /* #96 + #103: Actions column right padding */
        .pul-list__cell-actions {
            padding-right: 20px !important;
        }

        /* #99: Align copy icon with text baseline */
        .pul-copy-text {
            display: inline-flex;
            align-items: center;
            vertical-align: middle;
        }
    }
`;

export const EntityRowList = styled.div`
    .pul-list__table-container {
        overflow-x: visible;
    }
`;
